import {ControlInterface} from 'edocatbase/Form';
import {cleanFieldDirty, getNamesByNodes} from '../../actions/form';
import axios from 'axios';
import { Dispatch } from 'redux';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { countTitles, getValue, remapField } from '../../lib/asyncvalue';
const moment = window.moment;
import {  ListItemText  } from "@mui/material";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from '../../../Select/Async';
import TextField from '../../../TextField';

interface AsyncSelectProps extends ControlInterface, ReduxComponentInterface {
	formInstanceId: string;
	innerFormInstanceId?: string;
	readOnly: boolean;
	documentNodeRef: string | null;
	tableModal: any;
	helperText: any;
	important: any;
	searchDisabled: boolean;
}
interface AsyncSelectState {
	matchDisabled: boolean;
}

class AsyncSelect extends window.React.PureComponent<AsyncSelectProps, AsyncSelectState> {
	constructor(props: AsyncSelectProps) {
		super(props);
		this.state = {
			matchDisabled: false,
		};
	}
	fetchDetail = () => {
		const { actions, name, value, formInstanceId, innerFormInstanceId } = this.props;

		const data = (Array.isArray(value) ? value : typeof value === 'object' ? [value.nodeRef] : [value]).map(
			(it: any) => {
				if (it?.value) {
					return it.value.startsWith('{}') ? it.value.substr(2) : it.value;
				} else {
					return it?.startsWith('{}') ? it.substr(2) : it;
				}
			}
		);

		actions.getNamesByNodes(formInstanceId, name, data, innerFormInstanceId);
	};

	componentDidMount() {
		if (this.props.value) {
			this.fetchDetail();
		}
	}

	componentDidUpdate(_prevProps: AsyncSelectProps) {
		const { formInstanceId, dirty, name, onChange, actions, innerFormInstanceId } = this.props;
		dirty && onChange([name], this.props.value, true);
		actions.cleanFieldDirty(formInstanceId, name, innerFormInstanceId);
		if (
			this.props.value &&
			((Array.isArray(this.props.value) && this.props.value.some(item => !item.hasOwnProperty('value'))) ||
				(!Array.isArray(this.props.value) && !this.props.value.hasOwnProperty('value')))
		) {
			this.fetchDetail();
		}
		//Make fetch on update only if provided value is a nodeRef (also it could be a ready for use object).
		// if (this.props.value && !this.props.value.hasOwnProperty('value') && this.props.value !== prevProps.value) {
		//   this.fetchDetail();
		// }
	}

	// request creator allows only one request at a time,
	// others would be canceled
	makeRequestCreator = (name: string) => {
		let call: any;
		return (url: string) => {
			if (name === this.props.name && call) {
				call.cancel('Only one request allowed at a time.');
			}

			call = axios.CancelToken.source();
			return axios(url, {
				method: 'GET',
				withCredentials: true,
				cancelToken: call.token,
				headers: {
					[window.Alfresco.util.CSRFPolicy.getHeader()]: window.Alfresco.util.CSRFPolicy.getToken(),
				},
			});
		};
	};

	getAsyncOptions = this.makeRequestCreator(this.props.name);

	fetchOptionsAsync = (query: string) => {

		const { name, documentNodeRef, control: {params, params: {customQuery}} } = this.props;
		const searchParams: Record<string, any> = {
			name: params.qName,
			query: query,
			maxItems: '50',
			fid: name,
			_: moment().unix(),
		};

		if (documentNodeRef) {
			searchParams['nodeRef'] = documentNodeRef;
		}
		if (window.Alfresco.constants.SITE) {
			searchParams['site'] = window.Alfresco.constants.SITE
		}
		if (this.state.matchDisabled) {
			searchParams['all'] = 'true';
		}

		let url: string;
		if (customQuery?.fetchUrl) {
			searchParams['customFID'] = customQuery.srcKey
			searchParams['customValue'] = customQuery.srcValue
			url = `${window.appContext}/proxy/alfresco/${customQuery.fetchUrl}`;
		} else {
			url = `${window.appContext}/proxy/alfresco/emvc/codebook/byName`;
		}


		return this.getAsyncOptions(`${url}?${new URLSearchParams(searchParams)}`)
			.then(response => {
				if (response.status !== 200) {
					throw response;
				}

				return response.data;
			})
			.catch(reason => {
				throw reason;
			});
	};


	onSelectChange = (value: any) => {
		const { name, onChange } = this.props;
		onChange([name], value, true);
	};

	loadOptions = (searchTerm: string) => {
		return this.fetchOptionsAsync(searchTerm)
			.then(response => {
				const data = response.results[0]?.nodes?.data || [];
				//Count appearances of each codebook title.
				const titleCounts = countTitles(data);

				return data
					.map((row: any) => {
						const titleProp = row.values['prop_cm_title'];
						const title = titleProp.value;
						//If the title appears only once, don't add secondary text.
						if (titleCounts[title] === 1) {
							return remapField(row, '', titleProp.displayValue);
						}

						let valuesArray = Object.values(row.values).slice(0, 3);

						//If there is cm_title prop, add it as first value, for correct search
						if (
							valuesArray.filter(function (e) {
								return e === titleProp;
							}).length === 0
						) {
							valuesArray = [titleProp].concat(valuesArray);
						} else {
							valuesArray = valuesArray.filter(i => i !== titleProp);
							valuesArray = [titleProp].concat(valuesArray);
						}

						//Take values of the three initial codebook fields. If no value, use placeholder.
						const valuesArr = valuesArray.map((item: any) =>
							!item ? window.Alfresco.messages.global['label.none'] : item.displayValue
						);

						//If there are exactly 4 fields, push indicator
						if (valuesArr.length === 4) {
							valuesArr.push('(...)');
						}
						//The first field is always the key which is used as primary text and label.
						const [key, ...rest] = valuesArr;
						return remapField(row, rest.join(', '), key);
					})
					.sort((a: any, b: any) =>
						a.label.normalize('NFD').toLowerCase() > b.label.normalize('NFD').toLowerCase() ? 1 : -1
					);
			})
			.catch(reason => {
				throw reason;
			});
	};

	getDisabled = (event: React.MouseEvent) => {
		event?.preventDefault();
		this.setState({matchDisabled: !this.state.matchDisabled});
		return;
	}

	render() {
		const {
			autoFocus,
			disabled,
			label,
			value,
			repeating,
			mandatory,
			className,
			error,
			name,
			placeholder,
			readOnly,
			helperText,
			important,
			control,
			searchDisabled
		} = this.props;

		return readOnly || disabled ? (
			<div className={`form-row row-${name} ${readOnly ? 'simple-row' : 'read-only-row'}`}>
				<label>{label}</label>
				<div>{getValue(value)}</div>
			</div>
		) : (
			<div className={`form-row row-${name}`}>
				{readOnly ? (
					<TextField
						className={className}
						id={name}
						label={label}
						name={name}
						value={getValue(value)}
						readOnly={true}
					/>
				) : (
					<Select
						id={name}
						updateParam={control?.params?.customQuery?.srcValue ? this.props.control.params.customQuery.srcValue : ''}
						label={label}
						mandatory={mandatory}
						autoFocus={autoFocus}
						className={className}
						disabled={disabled}
						isClearable={!mandatory}
						multi={repeating}
						matchDisabled={searchDisabled ? this.state.matchDisabled : null}
						getDisabled={searchDisabled ? this.getDisabled : null}
						loadOptions={this.loadOptions}
						name={name}
						onChange={this.onSelectChange}
						value={repeating ? (Array.isArray(value) ? value : (typeof value === 'string' && value.length > 0 ? [value] : null)) : (value?.value ? value : null)}
						error={error}
						placeholder={placeholder}
						renderOption={(props, value: { label: string; secondaryText: string }) =>
							value.secondaryText ? <ListItemText {...props} primary={value.label} secondary={value.secondaryText} /> : <li {...props}>{value.label}</li>
						}
						helperText={helperText}
						important={important}
					/>
				)}
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: bindActionCreators({ getNamesByNodes, cleanFieldDirty }, dispatch),
});

export default connect(null, mapDispatchToProps)(AsyncSelect);
